<template>
  <div id="cards">
    <div
      class="card-item"
      v-for="(card, i) in cards"
      :key="card.title"
    >
      <div class="card-header">
        <div class="card-header-left">{{ card.title }}</div>
        <div class="card-header-right">{{ '0' + (i + 1) }}</div>
      </div>
      <dv-charts class="ring-charts" :option="card.ring" />
      <!-- <div class="card-footer">
        <div class="card-footer-item">
          <div class="footer-title">累计金额</div>
          <div class="footer-detail">
            <dv-digital-flop :config="card.total" style="width:70%;height:35px;" />元
          </div>
        </div>
        <div class="card-footer-item">
          <div class="footer-title">周度</div>
          <div class="footer-detail">
            <dv-digital-flop :config="card.num" style="width:70%;height:35px;" />处
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'Cards',
  computed: {...mapGetters(['workSheetTypeList','comeFromList','emergencyList','inOutList','mailTypeList'])},
  data () {
    return {
      cards: []
    }
  },
  methods: {
    createData () {
      const { randomExtend } = this
      this.cards.splice(0, this.cards.length)
      var obj1 = {}
      obj1.title = '工单类型分布'
      // obj1.total = {
      //   number: [randomExtend(9000, 10000)],
      //   content: '{nt}',
      //   textAlign: 'right',
      //   style: {
      //     fill: '#ea6027',
      //     fontWeight: 'bold'
      //   }
      // }
      // obj1.num = {
      //   number: [randomExtend(30, 60)],
      //   content: '{nt}',
      //   textAlign: 'right',
      //   style: {
      //     fill: '#26fcd8',
      //     fontWeight: 'bold'
      //   }
      // }
      obj1.ring = {
        series: [
          {
            name: '工单类型',
            type: 'pie',
            radius: '70%',
            center:['50%','50%'],
            data: this.workSheetTypeList,
            // position: 'inside',
            // startAngle:20,
            // itemStyle:{
            //   opacity:0.7
            // },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
             outsideLabel: {
                formatter: '{name} {value}%',
                labelLineEndLength: -1,
                style: {
                  fill: '#fff'
                },
                labelLineStyle: {
                  stroke: '#fff'
                }
              },
          }
        ],
        color: ['#03d3ec']
      }
      this.cards.push(obj1)

      var obj2 = {}
      obj2.title = '来源类型'
      // obj2.total = {
      //   number: [randomExtend(9000, 10000)],
      //   content: '{nt}',
      //   textAlign: 'right',
      //   style: {
      //     fill: '#ea6027',
      //     fontWeight: 'bold'
      //   }
      // }
      // obj2.num = {
      //   number: [randomExtend(30, 60)],
      //   content: '{nt}',
      //   textAlign: 'right',
      //   style: {
      //     fill: '#26fcd8',
      //     fontWeight: 'bold'
      //   }
      // }
      obj2.ring = {
        series: [
          {
            name: '来源',
            type: 'pie',
            radius: '70%',
            data: this.comeFromList,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
                
              }
            },
            outsideLabel: {
                formatter: '{name} {value}%',
                labelLineEndLength: 20,
                style: {
                  fill: '#fff'
                },
                labelLineStyle: {
                  stroke: '#fff'
                }
              },
          }
        ],
        color: ['#03d3ec']
      }
      this.cards.push(obj2)

      // var obj3 = {}
      // obj3.title = '紧急程度'
      // // obj3.total = {
      // //   number: [randomExtend(9000, 10000)],
      // //   content: '{nt}',
      // //   textAlign: 'right',
      // //   style: {
      // //     fill: '#ea6027',
      // //     fontWeight: 'bold'
      // //   }
      // // }
      // // obj3.num = {
      // //   number: [randomExtend(30, 60)],
      // //   content: '{nt}',
      // //   textAlign: 'right',
      // //   style: {
      // //     fill: '#26fcd8',
      // //     fontWeight: 'bold'
      // //   }
      // // }
      // obj3.ring = {
      //   series: [
      //     {
      //       name: '紧急程度',
      //       type: 'pie',
      //       radius: '50%',
      //       data: this.emergencyList,
      //       emphasis: {
      //         itemStyle: {
      //           shadowBlur: 10,
      //           shadowOffsetX: 0,
      //           shadowColor: 'rgba(0, 0, 0, 0.5)'
      //         }
      //       }
      //     }
      //   ],
      //   color: ['#03d3ec']
      // }
      // this.cards.push(obj3)

      var obj4 = {}
      obj4.title = '呼入呼出占比'
      // obj4.total = {
      //   number: [randomExtend(9000, 10000)],
      //   content: '{nt}',
      //   textAlign: 'right',
      //   style: {
      //     fill: '#ea6027',
      //     fontWeight: 'bold'
      //   }
      // }
      // obj4.num = {
      //   number: [randomExtend(30, 60)],
      //   content: '{nt}',
      //   textAlign: 'right',
      //   style: {
      //     fill: '#26fcd8',
      //     fontWeight: 'bold'
      //   }
      // }
      obj4.ring = {
        series: [
          {
            name: '占比',
            type: 'pie',
            radius: '70%',
            data: this.inOutList,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
             outsideLabel: {
                formatter: '{name} {value}%',
                labelLineEndLength: 20,
                style: {
                  fill: '#fff'
                },
                labelLineStyle: {
                  stroke: '#fff'
                }
              },
          }
        ],
        color: ['#03d3ec']
      }
      this.cards.push(obj4)

      var obj5 = {}
      obj5.title = '邮件类型'
      // obj5.total = {
      //   number: [randomExtend(9000, 10000)],
      //   content: '{nt}',
      //   textAlign: 'right',
      //   style: {
      //     fill: '#ea6027',
      //     fontWeight: 'bold'
      //   }
      // }
      // obj5.num = {
      //   number: [randomExtend(30, 60)],
      //   content: '{nt}',
      //   textAlign: 'right',
      //   style: {
      //     fill: '#26fcd8',
      //     fontWeight: 'bold'
      //   }
      // }
      obj5.ring = {
        series: [
          {
            name: '类型',
            type: 'pie',
            radius: '70%',
            data: this.mailTypeList,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
             outsideLabel: {
                formatter: '{name} {value}%',
                labelLineEndLength: 20,
                style: {
                  fill: '#fff'
                },
                labelLineStyle: {
                  stroke: '#fff'
                }
              },
          }
        ],
        color: ['#03d3ec']
      }
      this.cards.push(obj5)

    },
    randomExtend (minNum, maxNum) {
      if (arguments.length === 1) {
        return parseInt(Math.random() * minNum + 1, 10)
      } else {
        return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10)
      }
    }
  },
  async mounted () {
    const { createData } = this

    await this.$store.dispatch('screen/screenSet',{}).then(Response=>{
      createData();
    });

    setInterval(this.createData, 30000)
  }
}
</script>

<style lang="less">
#cards {
  display: flex;
  justify-content: space-between;
  height: 45%;

  .card-item {
    background-color: rgba(6, 30, 93, 0.5);
    border-top: 2px solid rgba(1, 153, 209, .5);
    width: 24%;
    display: flex;
    flex-direction: column;
  }

  .card-header {
    display: flex;
    height: 20%;
    align-items: center;
    justify-content: space-between;

    .card-header-left {
      font-size: 18px;
      font-weight: bold;
      padding-left: 20px;
    }

    .card-header-right {
      padding-right: 20px;
      font-size: 40px;
      color: #03d3ec;
    }
  }

  .ring-charts {
    height: 55%;
    margin-top:20px;
  }

  .card-footer {
    height: 25%;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .card-footer-item {
    padding: 5px 10px 0px 10px;
    box-sizing: border-box;
    width: 40%;
    background-color: rgba(6, 30, 93, 0.7);
    border-radius: 3px;

    .footer-title {
      font-size: 15px;
      margin-bottom: 5px;
    }

    .footer-detail {
      font-size: 20px;
      color: #1294fb;
      display: flex;
      font-size: 18px;
      align-items: center;

      .dv-digital-flop {
        margin-right: 5px;
      }
    }
  }
}
</style>
